import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './AdminSidebar.module.scss';

const AdminSidebar: React.FC = () => {
  const navItems = [
    { path: '/admin/prompts', label: 'Prompts' },
    { path: '/admin/evals', label: 'Evaluations' },
    { path: '/admin/benchmark', label: 'Benchmark' },
    { path: '/admin/document-upload', label: 'Document Upload' },
    { path: '/admin/summary-test', label: 'Summary Test' },
    { path: '/admin/search-test', label: 'Search Test' },
  ];

  return (
    <div className={styles.sidebar}>
      <div className={styles.nav}>
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
          >
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default AdminSidebar;
